import { createClient } from "@connectrpc/connect";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { MonitoreoUsuarioService } from "../../../../generated/grpc/configuracion_monitoreo_pb";
import { grpcMonitoreoUsuarioDatabase } from "../database/GrpcMonitoreoUsuarioDatabase";
import { MonitoreoUsuarioResponse } from "../response/MonitoreoUsuarioResponse";
import { fx_createMonitoreoUsuarioGrpcService, toMonitoreoUsuarioResponse } from "./MonitoreoUsuarioGrpcService";

/** Variante gRPC-Web de `MonitoreoUsuarioAccionesService` (ver ese archivo):
 *  activar, inactivar y reenviar credenciales. Son acciones puntuales sin
 *  concepto de delta -a diferencia de `ListByClienteId`-: no hay watermark
 *  que avanzar, solo un registro que patchear o un correo que reenviar. */
class MonitoreoUsuarioAccionesGrpcService {
  /** Habilita el acceso del monitor a la app. */
  async activarAsync(
    item: MonitoreoUsuarioResponse,
  ): Promise<MonitoreoUsuarioResponse> {
    return this._accionAsync(item, "activar");
  }

  /** Bloquea el acceso del monitor sin borrarlo (el server no expone DELETE). */
  async inactivarAsync(
    item: MonitoreoUsuarioResponse,
  ): Promise<MonitoreoUsuarioResponse> {
    return this._accionAsync(item, "inactivar");
  }

  /** Vuelve a enviarle el correo con su PIN e instrucciones de acceso. No
   *  devuelve contenido ni cambia el estado local. */
  async reenviarCredencialesAsync(
    item: MonitoreoUsuarioResponse,
  ): Promise<void> {
    const client = createClient(MonitoreoUsuarioService, grpcTransportProvider.get());
    try {
      await client.reenviarCredenciales({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }
  }

  /** Ejecuta una acción que devuelve el monitor actualizado, lo persiste e
   *  invalida el listado del cliente. */
  private async _accionAsync(
    item: MonitoreoUsuarioResponse,
    accion: "activar" | "inactivar",
  ): Promise<MonitoreoUsuarioResponse> {
    const client = createClient(MonitoreoUsuarioService, grpcTransportProvider.get());

    let actualizado;
    try {
      actualizado =
        accion === "activar"
          ? await client.activar({ id: item.id })
          : await client.inactivar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcMonitoreoUsuarioDatabase.putOneAsync(actualizado);
    fx_createMonitoreoUsuarioGrpcService(actualizado.clienteId).clearCache();

    return toMonitoreoUsuarioResponse(actualizado);
  }
}

/** Instancia única del servicio gRPC de acciones sobre monitores. */
export const monitoreoUsuarioAccionesGrpcService =
  new MonitoreoUsuarioAccionesGrpcService();
